<template>
  <ExActionsPopUp
    :value="show"
    headline="Delete Category"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Delete"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onDelete')"
    @input="$emit('onClose')"
    data-testid="delete-job-category-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="450"
  />
</template>

<script>
export default {
  name: "DeleteJobCategoryDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onDelete", "onClose"]);

const info = computed(
  () =>
    `<div style="max-width: 284px; margin: 0 auto; margin-top: 26px;">You are about to delete Category ${props.name}. This action is irreversible.</div>`
);
</script>
